module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/perugia.f878ebd38615aeb45caa8551950ce2dc.jpg";